<template>
    <multiselect :ref="`multiselect_${_uid}`"
                 :value="getValue"
                 :options="options"
                 :multiple="multiple"
                 :track-by="trackBy"
                 :show-labels="false"
                 :allow-empty="allowEmpty"
                 :class="{ 'multiselect--allow-empty': allowEmpty }"
                 open-direction="bottom"
                 v-bind="$attrs"
                 v-on="listeners"
                 @input="setValue">
        <template v-slot:caret="scope">
            <div v-if="allowEmpty && value" class="multiselect__reset" @mousedown.prevent.stop="$emit('input', null)" />
            <div class="multiselect__select" @mousedown.prevent.stop="scope.toggle" />
        </template>

        <template v-slot:option="scope">
            <slot name="option" v-bind="scope" />
        </template>

        <template v-slot:singleLabel="scope">
            <slot name="singleLabel" v-bind="scope" />
        </template>

        <template v-slot:noResult>
            По вашему запросу ничего не найдено.
        </template>

        <template v-slot:noOptions>
            Список пуст.
        </template>

        <!-- <template v-slot:noResult>
            <slot v-if="slotNoResultPassed" name="noResult" />
            <span v-else>По вашему запросу ничего не найдено</span>
        </template> -->

        <template v-slot:afterList>
            <slot name="afterList" />
        </template>
    </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

const findOption = (options, value, trackBy) => options.find(option => option[trackBy] === value)

export default {
    components: {
        Multiselect
    },

    props: {
        allowEmpty: {
            type: Boolean,
            default: true
        },
        value: {
            type: Object | Array | String | Number,
            default: null
        },
        options: {
            type: Array,
            default: _ => ([])
        },
        trackBy: {
            type: String,
            default: 'id'
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        getValue() {
            return this.multiple
                ? this.value.map(value => findOption(this.options, value, this.trackBy))
                : findOption(this.options, this.value, this.trackBy)
        },

        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        },

        slotNoOptionsPassed() {
            return this.$slots.noOptions !== undefined
        }

        /* slotNoResultPassed() {
            return this.$slots.noResult !== undefined
        } */
    },

    methods: {
        setValue(value) {
            if (value) {
                value = this.multiple ? value.map(value => value[this.trackBy]) : value[this.trackBy]
            }

            this.$emit('input', value)
        },

        reset() {
            this.localValue = null
        },

        select(value) {
            this.$refs[`multiselect_${this._uid}`].select(value)
        }
    }
}
</script>
